import TrustedHtml from '@components/common/TrustedHtml/TrustedHtml'
import Media from '@components/ui/Media/Media'
import { CardBlockCardFragment } from '@lib/umbraco/generated/types.generated'
import clsx from 'clsx'

import Link from '@components/common/Link/Link'
import React, { PropsWithChildren } from 'react'
import s from './CardBlockCardDefault.module.scss'
interface Props extends CardBlockCardFragment {}
type NativeAttrs = Omit<React.HTMLAttributes<HTMLLIElement>, keyof Props>

export type CardBlockCardDefaultProps = Props & NativeAttrs

const CardBlockCardDefault = React.forwardRef<
  HTMLLIElement,
  PropsWithChildren<CardBlockCardDefaultProps>
>(({ className, children, link, media, title, ...props }, ref) => {
  return (
    <li className={clsx(className, s.root)} ref={ref} {...props}>
      <Link link={link} className={s.link}>
        <div className={s.mediaWrapper}>
          <Media
            mediaWithCrops={media}
            mediaClassName={s.media}
            className={s.mediaContainer}
          />
        </div>

        <TrustedHtml html={title} />
      </Link>
    </li>
  )
})

CardBlockCardDefault.displayName = 'CardBlockCardDefault'
export default CardBlockCardDefault
